import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToTarget, scrollTop } from "@/lib/scroll";

// Scrolls to top on route change, or to the hashed element when present.
export function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => scrollToTarget(el), 200);
        return;
      }
    }
    scrollTop();
  }, [pathname, hash]);

  return null;
}
